import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import InputBase from '@material-ui/core/InputBase'
import IconButton from '@material-ui/core/IconButton'
import Message from './Message'
import ShowMore from './ShowMore'
import { sendMessage } from '../../../api'

const styles = theme => ({
    root: {
        width: '100%',
        //maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #e0e0e0',
        marginBottom: theme.spacing(2)
    },
    chip: {
        marginLeft: theme.spacing(1),
        //marginBottom: theme.spacing.unit * 1,
        minWidth: 60,
        whiteSpace: 'pre-wrap'
    },
    singleChip: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    confirmedChip: {
        background: '#43a047',
        color: 'white'
    },
    question: {
        fontWeight: 400,
        paddingLeft: 0
    },
    section1: {},
    section2: {
        margin: theme.spacing(2)
    },
    section3: {
        margin: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`
    },
    titleSection: {
        padding: theme.spacing(2),
        borderLeft: theme.spacing(1) + 'px solid ' + theme.palette.primary[500],
        borderBottom: '1px solid #e0e0e0'
    },
    mainTitleSection: {
        padding: theme.spacing(2),
        borderLeft: theme.spacing(2) + 'px solid ' + theme.palette.primary[700],
        borderBottom: '1px solid #e0e0e0',
        background: theme.palette.primary[500]
    },
    statusSection: {
        margin: `${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(1)}px`
    },
    title: {
        fontWeight: 500,
        fontSize: '1.2rem'
    },
    titleInfo: {
        fontWeight: 400,
        fontSize: '1.1rem',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.up(600)]: {
            textAlign: 'right',
            paddingRight: theme.spacing(1) + 'px!important'
        }
    },
    chipWrapper: {
        marginBottom: theme.spacing(1)
    },
    tableCell: {
        padding: `${theme.spacing(1)}px ${theme.spacing(0)}px ${theme.spacing(1)}px ${theme.spacing(1)}px`
    },
    thRowCell: {
        height: 45
    },
    lastRowCell: {
        borderBottom: 'none'
    },
    lastColumnCell: {
        paddingRight: theme.spacing(1) + 'px!important'
    },
    gaugeTitle: {
        textAlign: 'center',
        marginTop: theme.spacing(1)
    },
    statusBlue: {
        background: '#f7f7f7',
        border: '1px solid #e0e0e0',
        marginBottom: -1
    },
    statusText: {
        //color: 'white',
        fontWeight: 500,
        fontSize: '0.9rem'
    },
    greyStatusText: {
        color: 'grey',
        fontWeight: 400,
        fontSize: '0.9rem'
    },
    tableSection: {
        marginBottom: theme.spacing(1)
    },
    formControl: {
        maxWidth: 75
    },
    leftIcon: {
        marginRight: 10,
        marginLeft: -3
    },
    buttonSection: {
        textAlign: 'center',
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1)
    },
    iconButton: {
        minWidth: 40
    },
    sendMessageRoot: {
        borderBottom: '1px solid #e0e0e0',
        padding: `${theme.spacing(0.25)}px ${theme.spacing(1)}px ${theme.spacing(0.25)}px ${theme.spacing(1)}px`,
        display: 'flex',
        alignItems: 'center'
    },
    sendIconButton: {
        padding: 14
    },
    input: {
        marginLeft: 8,
        flex: 1
    },
    sendIcon: {}
})

class MessageList extends PureComponent {
    state = {
        showLimit: 2,
        newMessage: ''
    }

    onShowAll = () => {
        this.setState({ showLimit: null })
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value })
    }

    onSendMessage = () => {
        sendMessage({ applicationId: this.props.application.id, content: this.state.newMessage }).then(() => {
            this.setState({ newMessage: '' })
            this.props.refresh()
        })
    }

    render() {
        const { classes, messages, application } = this.props
        const { showLimit, newMessage } = this.state

        const shownMessages = showLimit ? messages.slice(0, showLimit) : messages
        const overflowY = showLimit ? 'hidden' : 'scroll'

        return (
            <>
                <Grid item xs={12}>
                    <div className={classes.statusBlue}>
                        <div className={classes.statusSection}>
                            <Grid container alignItems="center">
                                <Grid item xs={6} md={6}>
                                    <Typography variant="h5" className={classes.statusText}>
                                        Viestit
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} md={6}>
                                    <Typography variant="h5" className={classes.greyStatusText} align={'right'}>
                                        {application.title}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Grid>
                <div className={classes.root}>
                    {false && (
                        <div className={classes.sendMessageRoot} elevation={1}>
                            <InputBase
                                className={classes.input}
                                placeholder="Mitä haluaisit kysyä tai kertoa?"
                                name="newMessage"
                                value={newMessage}
                                onChange={this.handleChange}
                            />
                            <IconButton
                                color="primary"
                                className={classes.sendIconButton}
                                aria-label="Send"
                                onClick={this.onSendMessage}
                                disabled={newMessage === ''}
                            >
                                <FontAwesomeIcon size={'sm'} icon={['fal', 'paper-plane']} className={classes.sendIcon} />
                            </IconButton>
                        </div>
                    )}
                    <div
                        style={
                            showLimit
                                ? {
                                      overflowY: 'hidden',
                                      overflowX: 'hidden'
                                  }
                                : {
                                      overflowY: 'auto',
                                      overflowX: 'hidden',
                                      height: 347
                                  }
                        }
                    >
                        {shownMessages.map((message, key) => {
                            return (
                                <Message
                                    sender={{
                                        img: message.img,
                                        name: message.name,
                                        makeCircle: message.makeCircle
                                    }}
                                    message={{
                                        timestamp: message.timestamp,
                                        text: message.text,
                                        isSystemMessage: message.isSystemMessage
                                    }}
                                />
                            )
                        })}
                        {showLimit && messages.length > showLimit && <ShowMore onClick={this.onShowAll} />}
                    </div>
                </div>
            </>
        )
    }
}

export default withStyles(styles)(MessageList)
